export default __webpack_public_path__ + "static/media/transfer-eksternal.c4a416dd.png";